import { default as json69jozkGJDkRxURiVqDUbEY } from "./69jozkGJDkRxURiVqDUbEY.json";

const data: { [key: string]: any } = {
  "69jozkGJDkRxURiVqDUbEY": json69jozkGJDkRxURiVqDUbEY,
};

const content = {
  getByIdentifier: (contentIdentifier: string) => {
    const content = data[contentIdentifier];
    if (!content) {
      console.warn("Unable to find content with id:", contentIdentifier);
    }

    return content;
  },
};

export default content;
